import type { Node } from '../../../core/models/scene';
import { isLikelyStoredMediaObjectKey } from './mediaRefObjectKeyMatch';

export function extractStoredMediaObjectKeysFromNode(node: Node): string[] {
  const keys: string[] = [];
  const n = node as unknown as Record<string, unknown>;
  const props = n.props as Record<string, unknown> | undefined;
  const attrs = (props?.attrs ?? n.attrs) as Record<string, unknown> | undefined;
  const consider = (raw: unknown) => {
    if (typeof raw !== 'string') return;
    const t = raw.trim();
    if (isLikelyStoredMediaObjectKey(t)) keys.push(t);
  };
  consider(n.objectKey);
  consider(props?.objectKey);
  consider(attrs?.objectKey);
  consider(attrs?.photoRef);
  return keys;
}
